module.exports = __webpack_public_path__ + "9a36e3e7f8e9debca073a099c1935b5d.svg";